import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';
import { withRouter } from 'react-router';
import { deepCompare } from 'cityads-v3/utils/arrayUtils';
import { yandexReachGoal, googleEvent } from 'cityads-v3/utils/counterUtils';

import { getRegions } from 'cityads-v3/actions/offers';
import { getTimeZones } from 'cityads-v3/actions/timeZones';

import {
  setForm,
  saveForm,
  setError,
} from 'cityads-v3/actions/welcomeform';
import {
  menuProps,
  ANALYTICS_EVENTS,
  formItemIconSx
} from './WelcomeForm';

import Button from '@mui/material/Button'
import ListItemText from '@mui/material/ListItemText'
import MenuItem from '@mui/material/MenuItem'
import AutocompleteSelect from 'cityads-v3/components/AutocompleteSelect/AutocompleteSelect'
import TextField from 'cityads-v3/components/TextField/TextField';
import WaitingButton from 'cityads-v3/components/Buttons/WaitingButton';

import AddLocationOutlinedIcon from '@mui/icons-material/AddLocationOutlined'
import PermContactCalendarOutlinedIcon from '@mui/icons-material/PermContactCalendarOutlined';

import classes from './WelcomeForm.scss';

export function checkFields({ dispatch, form, inline }) {
  const errors = {};

  if (!form.country) {
    errors.country = true;
  }

  if (!form.timezone) {
    errors.timezone = true;
  }

  if (!inline && !form.currency) {
    errors.currency = true;
  }

  dispatch(setError(errors));

  return Object.keys(errors).length === 0;
}

@withRouter
@connect(state => {
  const timeZonesData = state.timeZones.timeZones.map(item => state.timeZones.timeZonesById[item]);
  let countryCodesData = {};
  timeZonesData.forEach(item => item.country_code && (countryCodesData[item.country_code] = true));
  countryCodesData = Object.keys(countryCodesData).sort((a,b) => a > b ? 1 : -1);

  const timeZonesByCountryCode = countryCodesData.reduce((prev, next) => ({
    ...prev,
    [next]: timeZonesData.filter(item => item.country_code === next)
  }), {});

  return {
    form: state.welcomeform.formData,
    contacts: state.welcomeform.formData.contacts,
    errors: state.welcomeform.errors,
    errorMessages: state.welcomeform.errorMessages,
    isSavingForm: state.welcomeform.isSavingForm,
    isSaveFailed: state.welcomeform.isSaveFailed,
    isLoadedRegions: state.offers.isLoadedRegions,
    isLoadedTimeZones: state.timeZones.isLoaded,

    language: state.language.language,

    timeZonesData,
    timeZonesByCountryCode,
    timeZonesById: state.timeZones.timeZonesById,
    countryCodesData,
    regionsById: state.offers.regionsById,
    regionsByCode: state.offers.regionsByCode,
    currenciesData: Object.values(state.currency.currencyById).filter(item => item.is_active),
  }
})
@withTranslation(['Welcome', 'main'], { i18n, wait: !!window })
export default class Step4 extends Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,

    history: PropTypes.object.isRequired,

    language: PropTypes.string,

    form: PropTypes.object.isRequired,
  }

  state = {
    timezoneCountry: ''
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      (!this.props.isLoadedRegions && newProps.isLoadedRegions) ||
      (this.props.form.country !== newProps.form.country)
    ) {
      this.initState(newProps);
    }
  }

  componentDidMount() {
    const { isLoadedRegions, isLoadedTimeZones, dispatch } = this.props;

    this.initState();

    if (!isLoadedRegions) {
      dispatch(getRegions());
    }

    if (!isLoadedTimeZones) {
      dispatch(getTimeZones());
    }
  }

  componentDidUpdate(prevProps) {
    const { dispatch, language } = this.props;

    if (language !== prevProps.language) {
      dispatch(getRegions());
      dispatch(getTimeZones());
    }
  }

  initState(props = this.props) {
    const { regionsById, isLoadedRegions } = props;
    const { country } = props.form;

    if (isLoadedRegions && country) {
      this.setState({timezoneCountry: (regionsById[country] || {}).code});
    }
  }

  checkField(name, newValue) {
    const { errors, dispatch, form } = this.props;
    const newForm = {
      ...form,
      [name]: newValue
    };
    const newErrors = {
      ...errors,
      [name]: !(newForm[name] && typeof newForm[name].length === 'undefined' ? true : newForm[name].length)
    }

    if (!deepCompare(newErrors, errors)) {
      dispatch(setError(newErrors));
    }
  }

  checkFields(props = this.props) {
    const { form, dispatch, inline } = props;

    return checkFields({ form, dispatch, inline });
  }

  goNext() {
    if (this.checkFields()) {
      yandexReachGoal(ANALYTICS_EVENTS.finish);
      googleEvent('WelcomeForm', ANALYTICS_EVENTS.finish);

      this.props.dispatch(saveForm('account_settings'))
        .then(() => {
          this.props.history.push('/publisher/offers');
        })
      ;
    }
  }

  goPrev() {
    this.props.dispatch(setForm({
      data: {},
      page: 3
    }));
  }

  handleChangeForm(name, newValue, check = true) {
    const { dispatch } = this.props;

    if (check) {
      this.checkField(name, newValue);
    }

    dispatch(setForm({
      data: {
        [name]: newValue
      },
      page: 4
    }));
  }

  renderTimeZones() {
    const { t, timeZonesData, timeZonesByCountryCode, errors, errorMessages } = this.props;
    const { timezone } = this.props.form;
    const timezones = this.state.timezoneCountry ? timeZonesByCountryCode[this.state.timezoneCountry] : timeZonesData;
    let dataSourceTimezone = [];

    if (timezones) {
      dataSourceTimezone = timezones.map(item => ({
        label: item.utc + ' ' + item.name,
        value: +item.id
      }));
    }

    return (
      <AutocompleteSelect
        label={t('fields.timezone')}
        fullWidth={true}
        classes={{ root: classes.autocomplete }}
        disabled={!this.state.timezoneCountry}
        openOnFocus={true}
        suggestions={dataSourceTimezone}
        error={!!errors.timezone}
        helperText={errors.timezone ? getErrorHelper(errorMessages.timezone) || t('errorEmptyField') : undefined}
        value={dataSourceTimezone.filter(ds => ds.value === timezone)[0] || null}
        onChange={selectedItem => {
          if (selectedItem) {
            this.handleChangeForm('timezone', selectedItem.value)
          }

          this.setState({
            timezoneText: (selectedItem && selectedItem.label) || null
          });
        }}
      />
    );
  }

  render() {
    const { t, isSavingForm, isSaveFailed, regionsById, regionsByCode, currenciesData, countryCodesData, errors, errorMessages, inline, inlineClasses = {} } = this.props;
    const { currency, country } = this.props.form;

    const dataSourceTimezoneCountry = countryCodesData
      .map(countryCode => regionsByCode[countryCode] || null)
      .map(countryId => (countryId && regionsById[countryId]) || null)
      .filter(country => !!country)
      .sort((country1, country2) => String(country1.name).localeCompare(country2.name))
      .map(item => ({
        label: item.name,
        value: item.code
      }))
    ;

    return (
      <div className={classNames(classes.form, classes.form__step3, inlineClasses.root)}>

        {!inline && (
          <div className={classes.form__title}>
            {t('step4')}
          </div>
        )}

        <div className={classNames(classes.form__items, inlineClasses.formItems)}>

          <div className={classes.form__item}>
            <AddLocationOutlinedIcon sx={formItemIconSx} />

            <AutocompleteSelect
              label={t('fields.country')}
              fullWidth={true}
              classes={{ root: classes.autocomplete }}
              openOnFocus={true}
              suggestions={dataSourceTimezoneCountry}
              error={!!errors.country}
              helperText={errors.country ? getErrorHelper(errorMessages.country) || t('errorEmptyField') : undefined}
              value={dataSourceTimezoneCountry.filter(ds => ds.value === (regionsById[country] && regionsById[country].code))[0] || null}
              onChange={selectedItem => {
                if (selectedItem) {
                  const country = regionsByCode[selectedItem.value];
                  this.setState({
                    timezoneCountry: selectedItem.value,
                    timezoneText: '',
                  });
                  this.handleChangeForm('country', country);
                  this.handleChangeForm('timezone', '', false);
                } else {
                  this.setState({
                    timezoneCountry: '',
                    timezoneText: '',
                    countryText: ''
                  });
                  this.handleChangeForm('country', '');
                  this.handleChangeForm('timezone', '');
                }
              }}
            />

            {inline ? null : this.renderTimeZones()}
          </div>

          {inline ?
            (
              <div className={classes.form__item}>
                <PermContactCalendarOutlinedIcon sx={formItemIconSx} />

                {this.renderTimeZones()}
              </div>
            ) :
            null
          }

          {inline ? undefined : (
            <div className={classes.form__item}>
              <PermContactCalendarOutlinedIcon sx={formItemIconSx} />

              <TextField
                select
                slotProps={{ select: menuProps }}
                label={t('fields.currency')}
                value={currency || ''}
                fullWidth={true}
                error={!!errors.currency}
                helperText={errors.currency ? getErrorHelper(errorMessages.currency) || t('errorEmptyField') : undefined}
                onChange={evt => {
                  this.handleChangeForm('currency', evt.target.value);
                }}
              >
                {currenciesData.map(item => (
                  <MenuItem
                    key={item.id}
                    value={item.id}
                  >
                    <ListItemText primary={item.name} />
                  </MenuItem>
                ))}
              </TextField>
            </div>
          )}

        </div>

        {isSaveFailed ?
          (
            <div className={classes.form__errors}>{t('saveError')}</div>
          ) :
          null
        }

        {!inline && (
          <div className={classes.buttons}>
            <Button onClick={() => this.goPrev()} color="info" variant="contained">{t('main:buttons.back')}</Button>
            <WaitingButton
              variant = "contained"
              color   = "primary"
              onClick = {() => this.goNext()}
              waiting = {isSavingForm}
            >
              {t('finish')}
            </WaitingButton>
          </div>
        )}
      </div>
    );
  }

}

function getErrorHelper(messages) {
  if (!messages) {
    return null;
  }

  return messages.map((m, i) => (<React.Fragment key={i}>{m}<br /></React.Fragment>))
}
